/* OrgPage auto-generated by npm run generator */
import { makeStyles, Theme, Typography } from "@material-ui/core"
import { PortalRole } from "@qlarity/common"
import OrgMenu from "components/molecules/dropdowns/OrgMenu"
import OrgPageTable from "components/molecules/OrgPageTable"
import { observer } from "mobx-react"
import React from "react"
import { useParams } from "react-router-dom"
import Store from "store/Store"
import { CsvButton } from "components/molecules/CsvButton"
import { useCollectionSubscribe } from "hooks/useSnapshots"

interface OrgPageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    orgPagePage: {
        display: "grid",
        gridGap: theme.spacing(8),
    },

    header: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: theme.spacing(2),
        gridAutoColumns: "max-content",
        alignItems: "center",
    },
}))

const OrgPage: React.FC<OrgPageProps> = (props) => {
    const classes = useStyles()
    const { orgId } = useParams()
    const clients = useCollectionSubscribe(Store.auth.clientCollection.where("orgId", "==", orgId))

    const { orgName, status } = Store.auth.getOrg(orgId)
    if (!orgId) {
        return <div>Org Not Found</div>
    }
    return (
        <div className={classes.orgPagePage}>
            <div className={classes.header}>
                <Typography variant="h5" display="inline">
                    Organization: {orgName}
                </Typography>
                <CsvButton clients={clients} />
                {Store.auth.portalUser?.role === PortalRole.ADMIN && <OrgMenu orgId={orgId} status={status} />}
            </div>
            <OrgPageTable />
        </div>
    )
}

export default observer(OrgPage)
